import { HttpHeaders, httpResource } from '@angular/common/http';
import { inject, Service } from '@angular/core';
import { REQUIRE_AUTH_HEADER } from '@psu-pennstateit-swe/utils/security';
import { ManagedArea, serverManagedAreaSchema, toManagedArea } from '@ssrm/core';
import { z } from 'zod';
import { SSRM_CONFIG } from '../app-properties.model';

@Service()
export class DelegationsData {
  // Swap url/mockUrl to enable hitting mock server
  private readonly baseUrl = inject(SSRM_CONFIG).mockUrl ?? inject(SSRM_CONFIG).url;
  private httpHeaders = new HttpHeaders({ [REQUIRE_AUTH_HEADER]: 'true' });

  managedAreasResource = () =>
    httpResource<ManagedArea[]>(() => ({ url: `${this.baseUrl}managedAreas`, headers: this.httpHeaders }), {
      parse: (response) => {
        const result = z.array(serverManagedAreaSchema.transform(toManagedArea)).safeParse(response);

        if (!result.success) {
          const details = result.error.issues
            .map((issue) => `${issue.path.join('.') || 'Response'}: ${issue.message}`)
            .join('\n');

          throw new Error(`Invalid /managedAreas response: <pre>${details}</pre>`);
        }

        return result.data;
      },
    });
}
